<div class="outlet-container d-flex fd-col ai-center">

  <div class="sidenav-container-position">
    <suvo-bi-list-navigation [showIcons]="true" [links]="manageOrganisationsLinks" class="sidenav-position show hide--lt-md">
    </suvo-bi-list-navigation>
  </div>

  <div [ngClass]="{'outlet-padding': !viewingSubscriptionsScreen, 'subscription-outlet-padding': viewingSubscriptionsScreen}">
    <suvo-core-route-toggle-group class="show--lt-md hide"></suvo-core-route-toggle-group>

    <router-outlet></router-outlet>
  </div>
</div>